import view from '../../../Enums';
import { makeStyle } from '../../../utils';
import { OYO_THEME } from '../../../resources/colors';
import { body2, bold, button, caption, columnCenter, h5, h6, rowCenter, subTitle1 } from '../../../resources/styles';

const styles = {};


styles['container'] = makeStyle({ overflowY: 'auto', height: '100%' });


styles['header'] = makeStyle({
    backgroundColor: 'white',
    width: '100%', minHeight: 60,
    display: 'flex',
    alignItems: 'center',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
});

styles['header_actions'] = makeStyle([rowCenter, { justifyContent: 'flex-end', fontWeight: 600 }], {}, {}, { marginRight: 4 });

styles['header_action'] = makeStyle({ margin: '4px 16px', fontSize: 14, display: 'flex' }, {}, {}, { margin: '4px 8px' });

styles['header_action_icon'] = makeStyle({}, {}, {}, { border: '1px solid', borderRadius: '50%', padding: 8, });

styles['header_action_text'] = makeStyle({ marginLeft: 4 }, {}, {}, { display: 'none' });


styles['oyo_logo'] = makeStyle({ alignSelf: 'center' }, { padding: 16 }, view.DESKTOP, { padding: 12 });


styles['back_link_arrow'] = makeStyle({ height: 18, width: 18 });


styles['header_text'] = makeStyle({
    fontWeight: 900, color: 'white', marginLeft: 24, padding: 16, textAlign: 'right',
}, { fontSize: 28 }, { fontSize: 20 }, { fontSize: 16, padding: 12, display: 'none' });

styles['header_text_small'] = makeStyle({ fontSize: 14 });


styles['image_containter'] = makeStyle({
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundColor: 'black',

    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    padding: '64px 0px',
}, {}, {}, { padding: '24px 0px' });


styles['left_card'] = makeStyle({ maxWidth: 356, padding: 12, margin: 12, color: 'white', fontSize: 19 }, {}, {}, { fontSize: 16 });

styles['left_card_heading'] = makeStyle({ ...h5, fontSize: 30 }, {}, {}, { fontSize: 22 });


styles['card_divider'] = makeStyle({}, { width: 48 });


styles['right_card'] = makeStyle({
    width: 300, borderRadius: 6, padding: 24, margin: 12, ...columnCenter, ...h6, ...bold, fontSize: 18,

    background: 'rgba(80, 80, 80, 0.30 )',
    boxShadow: '0 8px 32px 0 rgba(31, 38, 135, 0.37 )',
    backdropFilter: 'blur(4px)',
    borderRadius: 10,
    border: '1px solid rgba(255, 255, 255, 0.18 )',
    color: 'white',
    textAlign: 'center',
});

styles['start_button'] = makeStyle({
    borderRadius: 6,
    backgroundColor: 'var(--theme-color)',
    textAlign: 'center',
    color: 'white',
    padding: '8px 24px',
    margin: '24px auto 0',
    display: 'flex',
    alignItems: 'center',
    ...button,
});

styles['tandc_text_in_card'] = makeStyle([caption, { fontSize: 12, marginTop: 24 }]);

styles['tandc_link_in_card'] = makeStyle([caption, { fontSize: 12, color: 'var(--theme-color)', textDecoration: 'underline' }]);


styles['steps_container'] = makeStyle({ backgroundColor: '#eaeaea', paddingBottom: 32 });

styles['you_can_enter'] = makeStyle([h5, { textAlign: 'center', padding: 32 }]);

styles['steps'] = makeStyle({}, { display: 'flex' }, { display: 'flex', flexWrap: 'wrap' });

styles['step'] = makeStyle({ ...columnCenter, boxSizing: 'border-box', padding: 16 }, { flex: 1 }, { flex: 1, minWidth: '48%' });

styles['step_icon'] = makeStyle({ width: 64, height: 64, color: 'var(--theme-color)' });

styles['step_number'] = makeStyle(caption);

styles['step_content'] = makeStyle([subTitle1, { textAlign: 'center', marginTop: 16, maxWidth: 300 }], {}, {}, body2);

styles['sup'] = makeStyle({ lineHeight: '0px', color: OYO_THEME });


styles['tandc_container'] = makeStyle({ paddingBottom: 32, ...columnCenter });

styles['tandc_title'] = makeStyle([h5, { textAlign: 'center', padding: 32 }]);

styles['tandc_ol'] = makeStyle({ margin: 0, padding: '0 24px 0 40px' });

styles['tandc'] = makeStyle(subTitle1, {}, {}, body2);


export default styles;